export default "skymp5-front/829f95e76d69ad9cb5fe44102b69fac0.jpg";